import { render, staticRenderFns } from "./ButtonAnswer.vue?vue&type=template&id=b4a73746&"
import script from "./ButtonAnswer.vue?vue&type=script&lang=js&"
export * from "./ButtonAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports